import React from "react"
import { useStaticQuery, graphql } from "gatsby"
import { Breadcrumb } from "gatsby-plugin-breadcrumb"
import { getImage, GatsbyImage } from "gatsby-plugin-image"
import { videoTagString, VideoTag } from "react-video-tag"
import {
  PageHeaderWrap,
  VideoWrapper,
  BreadcrumbWrap,
} from "./page-header.style"

const PageHeader = ({
  esLinea,
  video,
  banner,
  pageContext,
  location,
  title,
}) => {
  const {
    breadcrumb: { crumbs },
  } = pageContext
  const disableLinks = []
  const customCrumbLabel = location.pathname.toLowerCase()
  const crumbLabelArr = customCrumbLabel.split("/")
  const label = crumbLabelArr[crumbLabelArr.length - 1]
  const labelArr = label.split("-")
  const bCrumbs = (
    <Breadcrumb
      title={esLinea ? `Línea ${title}` : title}
      crumbs={crumbs}
      crumbLabel={labelArr.join(" ")}
      disableLinks={disableLinks}
    />
  )
  const imageData = useStaticQuery(graphql`
    {
      file(relativePath: { eq: "header-bg.jpg" }) {
        childImageSharp {
          gatsbyImageData(height: 351, width: 1366, layout: FULL_WIDTH)
        }
      }
    }
  `)
  const gatsbyImage = banner?.gatsbyImage || null
  const fallbackUrl = banner?.fallbackUrl || null
  const staticImage = getImage(imageData.file)
  const posterSrc =
    gatsbyImage?.images?.fallback?.src ||
    fallbackUrl ||
    staticImage?.images?.fallback?.src
  if (video && video.url) {
    videoTagString({
      src: video.url,
      poster: posterSrc,
    })

    return (
      <VideoWrapper>
        <BreadcrumbWrap>{bCrumbs}</BreadcrumbWrap>

        <VideoTag
          autoPlay={`${true}`}
          muted={`${true}`}
          playsInline={`${true}`}
          loop={`${true}`}
          src={`${video.url}`}
          poster={posterSrc}
        />
      </VideoWrapper>
    )
  } else {
    return (
      <PageHeaderWrap>
        {gatsbyImage ? (
          <GatsbyImage
            image={gatsbyImage}
            alt="Fondo header"
            className="background-image"
          />
        ) : fallbackUrl ? (
          <img
            src={fallbackUrl}
            alt="Fondo header"
            className="background-image"
            style={{ width: "100%", height: "auto", objectFit: "cover" }}
          />
        ) : (
          <GatsbyImage
            image={staticImage}
            alt="Fondo header"
            className="background-image"
          />
        )}{" "}
        <div className="content-wrapper">{bCrumbs}</div>
      </PageHeaderWrap>
    )
  }
}

export default PageHeader
